import dynamic from "next/dynamic";

export const COMPONENTS_BY_TYPE = {
  heroSection: dynamic(() => import("./Hero")),
  multiBreakpointHero: dynamic(() => import("./Hero/MultiBPHero")),
  visualText: dynamic(() => import("./VisualText")),
  multiImageBlock: dynamic(() => import("./MultiImageBlock")),
  multiColumnBlock: dynamic(() => import("./MultiColumnBlock")),
  faqsBlock: dynamic(() => import("./FAQ")),
  customComponent: dynamic(() => import("../CustomComponent")),
  headingBanner: dynamic(() => import("./HeadingBanner")),
  basicRichText: dynamic(() => import("./BasicRichText")),
  clubHero: dynamic(() => import("./ClubHero")),
};

export const DynamicComponentByType = (props) => {
  const { entry } = props;
  // temporary support for pre-existing components
  const identifier = entry.type;

  const Component = COMPONENTS_BY_TYPE[identifier];

  if (Component) {
    return <Component {...props} />;
  }
  return null;
};
